// Group Model
cv.Group =  Backbone.RESTModel.extend({
  defaults : {
  },

  saveMap : {
    'label' : 'label'
  },

  urlRoot: function(){
    return cv.api_path + '/groups';
  },

  initialize: function(){
    console.log('Group model initialized.');
  }
});
Cocktail.mixin(cv.Group, cv.mixins.SyncModel);

// Groups Collection
cv.Groups = Backbone.Collection.extend({
  initialize: function(options){
    console.log('Group collection initialized.');
  },

  url: function() {
    return cv.api_path + "/groups?" + $.param(this.params);
  },

  model: cv.Group
});
Cocktail.mixin(cv.Groups, cv.mixins.PaginateModel);
